import { useState, useEffect } from 'react';

/**
 * Custom hook to manage selected project and scenario state with localStorage persistence
 * 
 * @returns {object} - { selectedProject, setSelectedProject, selectedScenario, setSelectedScenario }
 */
export const useProjectState = () => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedScenario, setSelectedScenario] = useState(null);

  // Load selected project and scenario from localStorage on mount
  useEffect(() => {
    const savedProject = localStorage.getItem('selectedProject');
    const savedScenario = localStorage.getItem('selectedScenario');
    
    if (savedProject) {
      try {
        setSelectedProject(JSON.parse(savedProject));
      } catch (err) {
        console.error('Error parsing saved project:', err);
        localStorage.removeItem('selectedProject');
      }
    }
    
    if (savedScenario) {
      try {
        setSelectedScenario(JSON.parse(savedScenario));
      } catch (err) {
        console.error('Error parsing saved scenario:', err);
        localStorage.removeItem('selectedScenario');
      }
    }
  }, []);

  // Persist selected project to localStorage when it changes
  useEffect(() => {
    if (selectedProject) {
      localStorage.setItem('selectedProject', JSON.stringify(selectedProject));
    } else {
      localStorage.removeItem('selectedProject');
    }
  }, [selectedProject]);

  // Persist selected scenario to localStorage when it changes
  useEffect(() => {
    if (selectedScenario) {
      localStorage.setItem('selectedScenario', JSON.stringify(selectedScenario));
    } else {
      localStorage.removeItem('selectedScenario');
    }
  }, [selectedScenario]);

  return {
    selectedProject,
    setSelectedProject,
    selectedScenario,
    setSelectedScenario
  };
};
